/**
 * Remove productSku's in cart from blueconic recommendations
 * #TODO: move this file to the shop plugin
 */

"use strict";

jQuery( function ($) {

    if ($('.woocommerce-page').length || $('.woocommerce').length ) {
        var productSku = [];
        waitForBlueconic();
    }

    //Blueconic has to be loaded first
    function waitForBlueconic(){
        if(typeof blueConicClient !== "undefined"){

            //if add to cart on single product page
            $('body').on('added_to_cart', function(e, fragments, hash, button) {
                productSku.push('"' + $(button).data('product_sku') + '"');
                blueconicSendCart();
            });

            //if on cart page
            if ($('.woocommerce-cart').length) {
                blueconicCart();
            }

            //update data if item is removed
            $('body').on('updated_cart_totals', function() {
                blueconicCart();
            });

            //if on thank you page get ID's of bought items
            if ($('.order-thanks').length) {
                $('.order_item').each(function (i) {
                    productSku.push('"' + $(this).data('product_sku') + '"');
                });
                blueconicSendOrdered();
            }
        }else{
            setTimeout(waitForBlueconic, 500);
        }
    }

    function blueconicCart() {
        //loop through all the cart items, first empty array
        productSku = [];
        $('.cart_item').each(function (i) {
            productSku.push('"' + $(this).data('product_sku') + '"');
        });

        blueconicSendCart();
    }

    function blueconicSendCart() {
        blueConicClient.event.publish("shoppingcart", { productIds: productSku, storeId: "4e4d9c9e-3f06-445c-be7b-d6fe381ec115"});
        //console.log('blueConicClient.event.publish("shoppingcart", { productIds: ['+productSku+'], storeId: "4e4d9c9e-3f06-445c-be7b-d6fe381ec115"})');
    }

    function blueconicSendOrdered() {
        blueConicClient.event.publish("order", { productIds: productSku, storeId: "4e4d9c9e-3f06-445c-be7b-d6fe381ec115"});
        //console.log('blueConicClient.event.publish("order", { productIds: ['+productSku+'], storeId: "4e4d9c9e-3f06-445c-be7b-d6fe381ec115"})');
    }
});